import CurrencySetup from './currency_setup';

const defaultCurrencySetup = CurrencySetup['AUD'];
let currentCurrencySetup = defaultCurrencySetup;

class CurrentCurrencySetup {
    static setCurrentCurrencySetup(currencySetup) {
        currentCurrencySetup = currencySetup;
    }

    static getCurrentCurrencySetup() {
        return currentCurrencySetup;
    }
}

export { CurrentCurrencySetup };